import { Controller } from "@hotwired/stimulus"

// Shows a live preview of a chosen avatar image before form submit.
// Works on any element that contains a file input and a preview container.
export default class extends Controller {
  static targets = ["input", "preview"]
  static values  = { defaultIcon: { type: String, default: "bi-person-fill" } }

  preview() {
    const file = this.inputTarget.files?.[0]
    if (!file || !file.type.startsWith("image/")) return

    const reader = new FileReader()
    reader.onload = (e) => {
      const el = this.previewTarget
      el.innerHTML = `<img src="${e.target.result}" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:inherit;">`
    }
    reader.readAsDataURL(file)
  }
}
